import { api } from "@/api/client";

export type HitachiInventory = {
  itemId: string;
  batchNumber: string;
  serialNumber: string;
};

export function getHitachiInventory(inventoryId: string) {
  return api.get<HitachiInventory[]>(`hitachi/inventory/${inventoryId}`);
}

export function getAssetNumbers(process: string) {
  return api.get<string[]>(`hitachi/inventory/assets?process=${process}`);
}

export function getLotNumbers(process: string, classification: string) {
  return api.get<string[]>(`hitachi/inventory/lotnumbers?process=${process}&classification=${classification}`);
}
